import * as cheerio from 'cheerio/slim';
class TmlResult {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(tml, embeds) {
        this._html = tml;
        this._meta = {};
        this.embeds = embeds;
    }
    get html() {
        return this._html;
    }
    set html(html) {
        // Automatically update the parsedHtml if the html value changed.
        if (this._parsedHtml && html !== this._html) {
            this._parsedHtml = cheerio.load(html, null, false);
        }
        this._html = html;
    }
    /**
     * The parsedHtml represents the html of the TmlResult instance but parsed to give a jQuery style
     * handle to the html body.
     */
    get parsedHtml() {
        if (!this._parsedHtml) {
            this._parsedHtml = cheerio.load(this.html, null, false);
        }
        return this._parsedHtml;
    }
    get meta() {
        return this._meta;
    }
    /**
     * Adds or updates the value for a meta attribute
     * @param {string} name
     * @param {*} value
     */
    setMeta(name, value) {
        this._meta[name] = value;
    }
}
export default TmlResult;
//# sourceMappingURL=TmlResult.js.map